/* ============================================================
   component-contact-form.js — Slice 22 Phase 1
   Minimal: double-submit guard only (Rule J12 — IIFE + dedup guard).

   On submit of a form inside .contact-form, disable the submit button so a
   second POST (double email) can't fire. The page does a native full-page
   POST + reload, so there is nothing to re-enable. No fetch/AJAX, no overlay,
   no sessionStorage — hCaptcha-safe (Rule F-CAPTCHA: native submit + reload).
   ============================================================ */
(function () {
  if (window.__kvContactFormBound) return;
  window.__kvContactFormBound = true;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('.contact-form')) return;

      var button = form.querySelector('.contact-form__submit, button[type="submit"]');
      if (!button) return;

      // Defer so the browser still includes the button in the POST, then lock it.
      window.setTimeout(function () {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      }, 0);
    },
    false
  );
})();
